import React, { useContext, useState, useEffect , Component} from 'react'

export default function HomePageHouse() {
    return(
      <div>
         <br></br><br></br><br></br><br></br><br></br><br></br>
        HomePageHouse
      </div>
    )
  }